import { createStore } from "vuex";

export default createStore({
  state: {
    allowBack: true,
  },
  mutations: {
    updateAppSetting(state, allowBack) {
      state.allowBack = allowBack;
    },
  },
  actions: {},
  modules: {},
});
